import React from 'react';
import { AttachmentsUploader } from '../AttachmentsUploader/AttachmentsUploader';

type FileInputProps = React.ComponentProps<typeof AttachmentsUploader>;

const FileInput: React.FC<FileInputProps> = props => (
  <AttachmentsUploader {...props} />
);

export { FileInput };
export type { FileInputProps };
